(ns frontend.view.nev.kyc.process.type-of-controlling-person-editor
  (:require

   [ui.components.input.checkbox :as checkbox]
   [ui.util :as uu]
   [common.schema.entities.workspace.kyc.kyc-utils :as ku]
   [common.localization :as loc]))

(defn view
  [{:keys [process-id question-attribute question-meta lang-kw answers-atom read-only?]
    :or {lang-kw :en}}]
  (let [info-text (get-in question-meta [:info lang-kw])
        value (get @answers-atom question-attribute {})
        entity-account-holders (get @answers-atom :kyc-controlling-person/lifeline-legal-names-of-the-entity-account-holders-for-which-is-controlling-person [])
        select-option-for-item (fn [item-label option-key]
                                 (swap! answers-atom update question-attribute
                                        (fn [prev]
                                          (let [prev (or prev {})]
                                            (update prev item-label
                                                    (fn [prev-selected-for-item]
                                                      (conj (set prev-selected-for-item) option-key)))))))
        deselect-option-for-item (fn [item-label option-key]
                                   (swap! answers-atom update question-attribute
                                          (fn [prev]
                                            (let [prev (or prev {})]
                                              (update prev item-label
                                                      (fn [prev-selected-for-item]
                                                        (disj (set prev-selected-for-item) option-key)))))))]
    [:div
     {:class "flex flex-col gap-3"}
     [:p
      {:class "text-base-light-text-paler text-sm m-0"}
      info-text]

     (->> entity-account-holders
          (map-indexed
           (fn [index item-label]
             (let [selected-for-item (set (get value item-label))]
               ^{:key (str item-label "-" index)}
               [:div
                {:class "rounded border py-2 px-3 flex flex-col gap-2"}
                [:p
                 {:class "font-semibold"}
                 item-label]

                [:p
                 {:class "text-sm m-0 text-base-light-text-paler"}
                 (loc/tr :please-provide-the-controlling-persons-status-by-ticking-appropriate-box)]

                [:ul
                 {:class "space-y-3"}
                 (->> question-meta
                      :options
                      (map (fn [option]
                             (let [option-key (:key option)
                                   input-id (str process-id "-" question-attribute "-" item-label "-" option-key)
                                   selected? (boolean (some #{option-key} selected-for-item))]
                               [:li
                                {:key input-id}
                                [:label
                                 {:for input-id
                                  :class (uu/cm "flex"
                                                (when-not read-only?
                                                  "cursor-pointer"))}
                                 [:div
                                  {:class "mr-2 mt-[2.5px]"}
                                  [checkbox/view
                                   {:id input-id
                                    :value selected?
                                    :on-change (fn [_e]
                                                 (if selected?
                                                   (deselect-option-for-item item-label option-key)
                                                   (select-option-for-item item-label option-key))
                                                 (deref answers-atom))
                                    :disabled? read-only?}]]

                                 (ku/localize option [] lang-kw)]])))
                      (doall))]]))))]))
